module.exports = __webpack_public_path__ + "img/new-banner.bcc57b08.svg";